import React from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import fanzinesMock from '../../../../mocks/fanzines.json'
import './publications-fanzines.css'

const resolveAssetPath = (assetPath) => {
  // assetPath viene como 'assets/img/fanzines/img_fanzine_cm_05.png'
  // Necesita ser relativo desde src/assets
  const resolvedAsset = require(`../../../../${assetPath}`)
  return resolvedAsset?.default || resolvedAsset
}

export default function PublicationsFanzines() {
  const fanzines = fanzinesMock.Fanzines.slice(0, 6)

  return (
    <section className='publications-fanzines section__padding'>
      <Container>
        <h2 className='publications-section__title'>Fanzines</h2>
        <Row className='g-4'>
          {fanzines.map((fanzine) => (
            <Col key={fanzine.id} md={6} lg={4} className='mb-4'>
              <a 
                href={fanzine.url}
                target='_blank'
                rel='noreferrer'
                className='publications-fanzine-card'
              >
                <div className='publications-fanzine-card__image-wrap'>
                  <Image 
                    src={resolveAssetPath(fanzine.imgUrl)}
                    alt={`Fanzine ${fanzine.id}`}
                    className='publications-fanzine-card__image'
                  />
                  <div className='publications-fanzine-card__overlay'>
                    <span className='publications-fanzine-card__cta'>Abrir</span>
                  </div>
                </div>
              </a>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}
